var $ = require('../internals/export');
var isArray = require('../internals/is-array');

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.array.is-array.js
// module id = 702
// module chunks = 49